const LONG_TEXT_QUESTION_REDUCER = (state, action) => state;

export {LONG_TEXT_QUESTION_REDUCER}